import { ReactNode, createContext, useContext, useState } from 'react';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { Dayjs } from 'dayjs';

type KalenderContext = {
  currentStartOfWeek: Dayjs;
  currentEndOfWeek: Dayjs;
  setCurrentStartOfWeek: (value: Dayjs) => void;
  setCurrentEndOfWeek: (value: Dayjs) => void;
};

const KalenderContext = createContext<KalenderContext>(null);

export function KalenderProvider({
  children,
  year,
}: {
  children: ReactNode;
  year: string;
}) {
  const [currentStartOfWeek, setCurrentStartOfWeek] = useState(
    dayjs().year(parseInt(year)).startOf('isoWeek'),
  );
  const [currentEndOfWeek, setCurrentEndOfWeek] = useState(
    dayjs().year(parseInt(year)).endOf('isoWeek'),
  );
  const value = {
    currentStartOfWeek,
    setCurrentStartOfWeek,
    currentEndOfWeek,
    setCurrentEndOfWeek,
  };

  return (
    <KalenderContext.Provider value={value}>
      {children}
    </KalenderContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useKalenderContext() {
  const kalenderContext = useContext(KalenderContext);
  return kalenderContext;
}
